<template>
  <div class="blocking-modal-wrapper">
    <div class="hide-content"></div>

    <div class="blocking-modal-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.toggleGlobalScrolling(true);
  },
  beforeDestroy() {
    this.toggleGlobalScrolling(false);
  },
};
</script>

<style scoped>
.hide-content {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 2;
  overflow: hidden;
  backdrop-filter: blur(5px);
  background: rgba(0, 0, 0, 0.4);
  opacity: 1;
  top: 0;
  left: 0;
}

.blocking-modal-content {
  background: #1d1d1b;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  position: fixed;
  top: 50%;
  padding: 2.5vh;
  transform: translateY(-50%);
  width: 90%;
  z-index: 10;
  left: 0;
  right: 0;
  margin: 0 auto;
}
@media (min-width: 768px) {
  .blocking-modal-content {
    width: 23.264vw;
    padding: 1.389vw;
  }
  .blocking-modal-content h4 {
    font-size: 1.389vw;
    line-height: 1.597vw;
  }
}
</style>
